module.exports = __webpack_public_path__ + "static/media/edit-24px.45b30f6a.svg";